import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import { fillUpLearningHoursGraph } from '../../hooks';

const LearningHoursGraph = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (data) {
      if (chartRef.current) {
        // Destroy the existing Chart instance
        chartRef.current.destroy();
      }
      fillUpLearningHoursGraph(data, chartRef);
    }
  }, [data]);


  return <canvas id="learningHoursGraph" width="400" height="200"></canvas>;
};

export default LearningHoursGraph;
